import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class UserManagementService {
  constructor(private httpClient: HttpClient) { }

  // ------------------- Function  Get -------------------
  public getMsUserAll() {
    return this.httpClient.get<any[]>(
      `${environment.url}/apiMsUser/getMsUserAll`
    );
  }

  public getMsUserByEndDatePro() {
    return this.httpClient.get<any[]>(
      `${environment.url}/apiMsUser/getMsUserByEndDatePro`
    );
  }

  public getManager() {
    return this.httpClient.get<any[]>(
      `${environment.url}/apiMsUser/getManager`
    );
  }

  public getAllManager() {
    return this.httpClient.get<any[]>(
      `${environment.url}/apiMsUser/getAllManager`
    );
  }

  public getAllLead() {
    return this.httpClient.get<any[]>(
      `${environment.url}/apiMsUser/getAllLead`);
  }

  public getMsUserByEmail(email: any) {
    return this.httpClient.get<any[]>(
      `${environment.url}/apiMsUser/getMsUserByEmail/${email}`
    );
  }

  public getMsUserById(id: any) {
    return this.httpClient.get<any[]>(
      `${environment.url}/apiMsUser/getMsUserById/${id}`
    );
  }

  public findMsUsersWithPaginationAndSorting(
    offset: number,
    pageSize: number,
    field: string,
    isAscending: boolean,
    searchText: string,
    isCheckActive: boolean
  ): Observable<any> {
    let params = new HttpParams();
    if (isAscending != null) {
      params = params.append("isAscending", isAscending);
    }
    if (searchText != null) {
      params = params.append("searchText", searchText);
    }
    if (isCheckActive != null) {
      params = params.append("active", isCheckActive);
    }
    return this.httpClient.get<any[]>(
      `${environment.url}/apiMsUser/findMsUsersWithPaginationAndSorting/${offset}/${pageSize}/${field}`,
      { params: params }
    );
  }

  // ------------------- Function  Get Search -------------------
  public getUserFilter(searchText: string): Observable<any> {
    let params = new HttpParams();
    if (searchText != null) {
      params = params.append("searchText", searchText);
    }
    /*
    if (fullName != null) {
      params = params.append('fullName', fullName);
    }

    if (status != null) {
      params = params.append('status', status);
    } */

    return this.httpClient.get<any>(
      `${environment.url}/apiMsUser/getUserFilter`,
      { params: params }
    );
  }

  // ------------------- Function  Post -------------------
  public addMsUser(
    id: any,
    title: any,
    firstName: any,
    lastName: any,
    email: any,
    password: any,
    createdDate: any,
    createdBy: any,
    updatedDate: any,
    updatedBy: any,
    isDelete: any,
    resetToken: any,
    gender: any,
    birthDate: any,
    perId: any,
    empId: any,
    empType: any,
    startDate: any,
    endDate: any,
    tel: any,
    lineauthId: any,
    houseAddress: any,
    currentAddress: any,
    username: any,
    titleTh: any,
    firstNameTh: any,
    accNumber: any,
    maritalStatus: any,
    lastNameTh: any,
    firstNameCon: any,
    lastNameCon: any,
    relation: any,
    telCon: any,
    empTypeId: any,
    positionId: any,
    startDatePro: any,
    endDatePro: any,
    startDatePro2: any,
    endDatePro2: any,
    passPro1: any,
    passPro2: any,
    isTrainee: any,
    msUserRoleModelList: any,
    msUserLeaveModelList: any,
    leadId: any,
    nickNameTh: any,
    nickName: any,
    proStatus: any,
  ) {
    return this.httpClient.post<any>(`${environment.url}/apiMsUser/addMsUser`, {
      id,
      title,
      firstName,
      lastName,
      email,
      password,
      createdDate,
      createdBy,
      updatedDate,
      updatedBy,
      isDelete,
      resetToken,
      gender,
      birthDate,
      perId,
      empId,
      empType,
      startDate,
      endDate,
      tel,
      lineauthId,
      houseAddress,
      currentAddress,
      username,
      titleTh,
      firstNameTh,
      accNumber,
      maritalStatus,
      lastNameTh,
      firstNameCon,
      lastNameCon,
      relation,
      telCon,
      empTypeId,
      positionId,
      startDatePro,
      endDatePro,
      startDatePro2,
      endDatePro2,
      passPro1,
      passPro2,
      isTrainee,
      msUserRoleModelList,
      msUserLeaveModelList,
      leadId,
      nickNameTh,
      nickName,
           proStatus,
    });
  }

  // ------------------- Function  Put -------------------
  public updateMsUser(
    id: any, //
    title: any, //
    titleTh: any, //
    firstName: any, //
    lastName: any, //
    email: any, //
    gender: any, //
    birthDate: any, //
    perId: any, //
    empId: any, //
    empType: any, //
    startDate: any, //
    endDate: any, //
    status: any, //
    tel: any, //
    homePhone: any, //
    lineauthId: any, //
    houseAddress: any, //
    currentAddress: any, //
    firstTime: any, //
    username: any, //
    firstNameTh: any, //
    accNumber: any, //
    maritalStatus: any, //
    lastNameTh: any, //
    firstNameCon: any, //
    lastNameCon: any, //
    relation: any, //
    telCon: any, //
    empTypeId: any, //
    positionId: any, //
    nickName: any, //
    nickNameTh: any, //
    startDatePro: any,
    endDatePro: any,
    startDatePro2: any,
    endDatePro2: any,
    passPro1: any,
    passPro2: any,
    isTrainee: any,
    proStatus: any,
    msUserRoleModelList: any,
    msUserLeaveModelList: any,
    leadId: any
  ) {
    return this.httpClient.put<any>(
      `${environment.url}/apiMsUser/updateMsUser`,
      {
        id,
        title,
        titleTh,
        firstName,
        lastName,
        email,
        gender,
        birthDate,
        perId,
        empId,
        empType,
        startDate,
        endDate,
        status,
        tel,
        homePhone,
        lineauthId,
        houseAddress,
        currentAddress,
        firstTime,
        username, //
        firstNameTh, //
        accNumber, //
        maritalStatus, //
        lastNameTh, //
        firstNameCon, //
        lastNameCon, //
        relation, //
        telCon, //
        empTypeId, //
        positionId, //
        nickName, //
        nickNameTh, //
        startDatePro,
        endDatePro,
        startDatePro2,
        endDatePro2,
        passPro1,
        passPro2,
        isTrainee,
        proStatus,
        msUserRoleModelList,
        msUserLeaveModelList,
        leadId,
      }
    );
  }

  public updateStatus(id: any, status: any, empTypeId: any, endDate: any) {
    return this.httpClient.put<any>(
      `${environment.url}/apiMsUser/updateStatus`,
      {
        id,
        status,
        empTypeId,
        endDate,
      }
    );
  }

  public updatePassword(id: any, password: any, firstTime: any) {
    return this.httpClient.put<any>(
      `${environment.url}/apiMsUser/updatePassword`,
      {
        id,
        password,
        firstTime,
      }
    );
  }

  public updatePDPA(id: any, checkPDPA: any) {
    return this.httpClient.put<any>(`${environment.url}/apiMsUser/updatePDPA`, {
      id,
      checkPDPA,
    });
  }

  public getMsUserActive() {
    return this.httpClient.get<any[]>(
      `${environment.url}/apiMsUser/getMsUserActive`
    );
  }

  findUserPaginationWithSortingByLead(
    offset: number,
    pageSize: number,
    field: string,
    isAscending: boolean,
    leadId: number,
    thisyear: number,
    lastmonth: number,
    nowTab: string,
    keyword: string
  ): Observable<any> {
    let params = new HttpParams();
    if (isAscending != null) {
      params = params.append("isAscending", isAscending);
    }
    if (keyword != null) {
      params = params.append("keyword", keyword);
    }
    return this.httpClient.get<any[]>(
      `${environment.url}/apiMsUser/findUserPaginationWithSortingByLead/${offset}/${pageSize}/${field}/${leadId}/${thisyear}/${lastmonth}/${nowTab}`,
      { params: params }
    );
  }

  findUsersByManagerIdWithPaginationAndSorting(
    isAscending: boolean,
    field: string,
    pageNo: number,
    pageSize: number,
    id: number,
    keyword: string,
    isActive?: boolean
  ): Observable<any> {
    let params = new HttpParams();
    if (isAscending != null) {
      params = params.append("isAscending", isAscending);
    }
    if (field != null) {
      params = params.append("field", field);
    }
    if (pageNo != null) {
      params = params.append("pageNo", pageNo);
    }
    if (pageSize != null) {
      params = params.append("pageSize", pageSize);
    }
    if (id != null) {
      params = params.append("id", id);
    }
    if (keyword != null) {
      params = params.append("keyword", keyword);
    }
    if (isActive != null) {
      params = params.append("isActive", isActive);
    }

    return this.httpClient.get<any[]>(
      `${environment.url}/apiMsUser/findUsersByManagerIdWithPaginationAndSorting`,
      { params: params }
    );
  }
}
